import React, {useState} from "react";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import ComicsViewerPopup from "./ComicsViewerPopup";
import Helper from "../../../services/Helper";

function ComicsViewer() {

    const { user } = useTypedSelector(state => state.auth);
    const [showComics, setShowComics] = useState(false);
    type ComicsSetting = {
        path: string;
        slideNumber: number;
        animatedSlides: number[] | null;
        backgroundPath: string | null,
        backgroundSize: any
    };

    const [comicsSetting, setComicsSetting] = useState<ComicsSetting>({
        path: '',
        slideNumber: 0,
        animatedSlides: null,
        backgroundPath: null,
        backgroundSize: null
    });

    const arrayOfComics = [
        {'name': 'Magical lessons - Step 1', 'bot_id':34, 'path': './img/stories/tutorial/1_after_1st_battle/', 'slideNumber':5 },
        {'name': 'Magical lessons - Step 2', 'bot_id':35, 'path': './img/stories/tutorial/2_after_2nd_battle/', 'slideNumber':4},
        {'name': 'Magical lessons - Win', 'bot_id':36, 'path': './img/stories/tutorial/3_after_3th_battle/', 'slideNumber':6 , 'animatedSlides': [4] },

        {'name': 'Lust Tower - Step 1', 'bot_id':49,       path: './img/stories/lust_tower/first_win/', slideNumber: 4, backgroundPath: './img/stories/lust_tower/first_win/bg.webp', backgroundSize:{x:1280, y:698} },
        {'name': 'Lust Tower - Step 2', 'bot_id':50,       path: './img/stories/lust_tower/second_win/', slideNumber: 3, backgroundPath: './img/stories/lust_tower/second_win/bg.webp', backgroundSize:{x:1280, y:698} },
        {'name': 'Lust Tower - Step 3', 'bot_id':51,       path: './img/stories/lust_tower/after_3_win/', slideNumber: 4, backgroundPath: './img/stories/lust_tower/after_3_win/bg.webp', backgroundSize:{x:1280, y:698} },

        {'name': 'Elf - Intro', 'bot_id':6, 'path': './img/stories/elf/intro/', 'slideNumber':6 },
        {'name': 'Elf - Win', 'bot_id':7, 'path': './img/stories/elf/win/', 'slideNumber':32 },

        {'name': 'Gabriela - Intro', 'bot_id':2, 'path': './img/stories/gabby/intro/', 'slideNumber':25 },
        {'name': 'Gabriela - Win', 'bot_id':4, 'path': './img/stories/gabby/win/', 'slideNumber':8 },

        {'name': 'Kailis part 1 - Intro', 'bot_id':9, 'path': './img/stories/kailis/intro/', 'slideNumber':13 },
        {'name': 'Kailis part 1 - Win', 'bot_id':11, 'path': './img/stories/kailis/win/', 'slideNumber':29 },
        {'name': 'Kailis part 1 - Lose', 'bot_id':11, 'path': './img/stories/kailis/lose/', 'slideNumber':6 },

        {'name': 'Kailis part 2 - Intro', 'bot_id':12, 'path': './img/stories/kailis_heretic/intro/', 'slideNumber':9 },
        {'name': 'Kailis part 2 - Win', 'bot_id':14, 'path': './img/stories/kailis_heretic/win/', 'slideNumber':10 },

        {'name': 'Tower part 1 - Intro', 'bot_id':17, 'path': './img/stories/tower/intro/', 'slideNumber':6 },
        {'name': 'Tower part 1 - Win', 'bot_id':15, 'path': './img/stories/tower/win/', 'slideNumber':15 },

        {'name': 'Tower part 2 - Intro', 'bot_id':20, 'path': './img/stories/tower_escape/intro/', 'slideNumber':22 },
        {'name': 'Tower part 2 - Win', 'bot_id':18, 'path': './img/stories/tower_escape/win/', 'slideNumber':13 },

        {'name': 'Troll - Intro', 'bot_id':22, 'path': './img/stories/troll/intro/', 'slideNumber':18 },
        {'name': 'Troll - Win', 'bot_id':24, 'path': './img/stories/troll/win/', 'slideNumber':8 },

        {'name': 'Vampires - Intro', 'bot_id':28, 'path': './img/stories/vampire/intro/', 'slideNumber':22 },
        {'name': 'Vampires - Win', 'bot_id':30, 'path': './img/stories/vampire/win/', 'slideNumber':8, 'animatedSlides': [8] },

        {'name': 'Sea Adventures - Intro', 'bot_id':31, 'path': './img/stories/sea_adv/intro/', 'slideNumber':23 },
        {'name': 'Sea Adventures - Win', 'bot_id':33, 'path': './img/stories/sea_adv/win/', 'slideNumber':19, 'animatedSlides': [11,12] },

        {'name': 'Island Adventures - Intro', 'bot_id':45, 'path': './img/stories/island_adv/1_intro/', 'slideNumber':6 },
        {'name': 'Island Adventures- Step 1', 'bot_id':46, 'path': './img/stories/island_adv/2_after_1st_battle/', 'slideNumber':6},
        {'name': 'Island Adventures- Step 2', 'bot_id':46, 'path': './img/stories/island_adv/3_after_2nd_battle/', 'slideNumber':6},
        {'name': 'Island Adventures - Win', 'bot_id':47, 'path': './img/stories/island_adv/4_after_3rd_battle/', 'slideNumber':19 , 'animatedSlides': [8] },
    ];



    return <>
        {showComics ?
            <ComicsViewerPopup comicsSetting={comicsSetting} closeComics={() => setShowComics(false)} />
           : null
        }
    <div className={'comicsViewerContainer'}>
        <Swiper
            modules={[Navigation]}
            spaceBetween={1}
            slidesPerView={4}
            loop={false}
            navigation={{
                prevEl: '.swiper-button-prev-com',
                nextEl: '.swiper-button-next-com',
            }}
        >

            {arrayOfComics.map((comics, index) =>
                user.maps.includes(comics.bot_id) ? (
                    <SwiperSlide key={index + 'comics'}>
                        <div className={'comicsViewerSlide'} onClick={()=>{
                            setShowComics(true);

                            setComicsSetting({
                                'path':comics.path,
                                'slideNumber':comics.slideNumber,
                                'animatedSlides': comics.animatedSlides ?? null,
                                'backgroundPath': comics.backgroundPath ?? null,
                                'backgroundSize': comics.backgroundSize ?? null
                            });
                        }}>
                            <div className={'comicsViewerSlideName'}>{comics.name}</div>
                            <img
                                className="comicsViewerImg"
                                src={Helper.getRealComicsPath(comics.path) + 'preview.webp'}
                                alt={comics.name}
                                onError={(e) => {
                                    e.currentTarget.src = Helper.getRealComicsPath(comics.path) + '1.webp';
                                }}
                            />
                        </div>
                    </SwiperSlide>
                ) : null
            )}

        </Swiper>
        <div className="swiper-button-prev swiper-button-prev-com"></div>
        <div className="swiper-button-next swiper-button-next-com"></div>
    </div>
        </>
}
export default ComicsViewer;
